import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconAiBotHeadLooking: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAiBotHeadLooking"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M11.25 9V13" stroke="currentColor" strokeWidth="1.25"/><Path d="M15.75 9V13" stroke="currentColor" strokeWidth="1.25"/></CentralIconBase>;
});

export default IconAiBotHeadLooking;
